import { render, staticRenderFns } from "./BaseMap.vue?vue&type=template&id=2298d2a8&"
import script from "./BaseMap.vue?vue&type=script&lang=js&"
export * from "./BaseMap.vue?vue&type=script&lang=js&"
import style0 from "./BaseMap.vue?vue&type=style&index=0&id=2298d2a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports